export default __webpack_public_path__ + "static/media/Error404Icon.3309f159.svg";